import React from "react";
import {useGetGroups} from "./matchesHooks";
import MatchCard from "../shared/MatchCard";
import {type MatchDisplay} from '@iziping/common';

interface GroupContainerProps {
    heatId: number;
}

const Groups: React.FC<GroupContainerProps> = ({heatId}) => {
    const {data: groups, isLoading: isGroupLoading, isError: isGroupsError} = useGetGroups(heatId);

    if (isGroupLoading) {
        return <div>Loading</div>
    }
    if (isGroupsError) {
        return <div>Error</div>
    }

    return (
        <div className={'container-item'}>
            {groups?.map((match: MatchDisplay) =>
                <MatchCard match={match}/>
            )}
        </div>
    )
}

export default Groups;